// extracted by mini-css-extract-plugin
export default {"rowBox":"gdeyubgD5ZBpfuBJYALD"};